'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _ConfigStore = require('./ConfigStore');

var _ConfigStore2 = _interopRequireDefault(_ConfigStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var networks = {
  facebook: new RegExp(/(facebook|fb\.me)/),
  twitter: new RegExp(/(twitter)/),
  pinterest: new RegExp(/(pinterest)/),
  instagram: new RegExp(/(instagram)/),
  youtube: new RegExp(/(youtube|youtu\.be)/),
  houzz: new RegExp(/(houzz)/),
  googleplus: new RegExp(/(plus\.google)/),
  linkedin: new RegExp(/(linkedin)/),
  buzzbuzzhome: new RegExp(/(buzzbuzzhome)/),
  vimeo: new RegExp(/(vimeo)/)
};

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function getIconForUrl(url, overrideIcons) {
  var icons = _ConfigStore2.default.getConfig('social_links', {});

  var urlNetwork = (0, _keys2.default)(networks).reduce(function (result, network) {
    var regex = networks[network];
    if (!result && regex.test(url)) {
      return network;
    }

    return result;
  }, false);

  if (!_lodash2.default.has(icons, urlNetwork) && !_lodash2.default.has(overrideIcons, urlNetwork)) {
    return [icons.fallback, url];
  } else if (_lodash2.default.has(overrideIcons, urlNetwork)) {
    return [overrideIcons[urlNetwork], capitalizeFirstLetter(urlNetwork)];
  }

  return [icons[urlNetwork], capitalizeFirstLetter(urlNetwork)];
}

function SocialLink(_ref) {
  var url = _ref.url,
      icons = _ref.icons;

  var _getIconForUrl = getIconForUrl(url, icons),
      _getIconForUrl2 = (0, _slicedToArray3.default)(_getIconForUrl, 2),
      imageUrl = _getIconForUrl2[0],
      alt = _getIconForUrl2[1];

  return _react2.default.createElement(
    'a',
    { href: url, target: '_blank', rel: 'noopener noreferrer' },
    _react2.default.createElement('img', { src: imageUrl, alt: alt })
  );
}

SocialLink.propTypes = {
  url: _propTypes2.default.string.isRequired,
  icons: _propTypes2.default.object
};

SocialLink.defaultProps = {
  icons: {}
};

exports.default = SocialLink;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-utilities/build/SocialLink.js
// module id = 1097
// module chunks = 0